import { BedDouble, Waves, Images, Rotate3d, MapPin, Star, HelpCircle, Mail } from 'lucide-react';

// Public site pages — one route per main-menu section, in every language (EN at root, others under /:lang).
export const PAGES = [
  { slug: 'rooms', key: 'nav.rooms', icon: BedDouble },
  { slug: 'amenities', key: 'nav.amenities', icon: Waves },
  { slug: 'gallery', key: 'nav.gallery', icon: Images },
  { slug: 'virtual-tour', key: 'nav.virtualTour', icon: Rotate3d },
  { slug: 'location', key: 'nav.location', icon: MapPin },
  { slug: 'reviews', key: 'nav.reviews', icon: Star },
  { slug: 'faq', key: null, label: 'FAQ', icon: HelpCircle },
  { slug: 'contact', key: 'nav.contact', icon: Mail },
];
export const SLUGS = PAGES.map((p) => p.slug);
// Public pages that are not in the main menu (room detail pages live under /rooms/<slug>).
export const EXTRA_SLUGS = ['guides', 'privacy-policy', 'cookie-policy', 'terms', 'imprint'];
export const SITE_SLUGS = [...SLUGS, ...EXTRA_SLUGS];
export const LANGS = ['en', 'me', 'sq', 'de', 'pl', 'ru', 'hu', 'ro'];

// Old single-page anchors → the page that now holds that section (anchors still on the home page are omitted).
export const ANCHOR_TO_SLUG = { amenities: 'amenities', gallery: 'gallery', social: 'gallery', 'virtual-tour': 'virtual-tour', location: 'location', explore: 'location', faq: 'faq', contact: 'contact' };

export const langPath = (language, slug = '') => {
  if (language === 'en') return slug ? `/${slug}` : '/';
  return slug ? `/${language}/${slug}` : `/${language}`;
};

// "/de/rooms" → { lang: 'de', slug: 'rooms' }; "/rooms" → { lang: 'en', slug: 'rooms' }; "/" → { lang: 'en', slug: '' }
export const parsePath = (pathname) => {
  const parts = pathname.split('/').filter(Boolean);
  let lang = 'en';
  if (parts[0] && LANGS.includes(parts[0]) && parts[0] !== 'en') lang = parts.shift();
  return { lang, slug: parts[0] || '' };
};

export const pageLabel = (page, t) => (page.key ? t(page.key) : page.label);
